/* Colour words (Italian first, a few English too) → swatch colours. Longer phrases are matched first. */
var LU_SWATCH = (function () {
  var C = [
    ['carta da zucchero', '#86A0BA'], ['verde oliva', '#6E7140'], ['blu notte', '#1F2B48'], ['blue navy', '#1F2B48'], ['navy', '#1F2B48'],
    ['rosso lava', '#A8321F'], ['marrone cammello', '#A57A4E'], ['bianco cotone', '#F4F1E8'], ['nero carbone', '#2B2B2B'],
    ['bianco caldo', '#FFE2A8'], ['bianco freddo', '#E6F1FF'], ['bianco naturale', '#FFF6E6'], ['grigio cenere', '#B5B2AA'], ['grigio scuro', '#55565A'],
    ['warm white', '#FFE2A8'], ['cold white', '#E6F1FF'], ['cool white', '#E6F1FF'], ['olive green', '#6E7140'],
    ['bordeaux', '#5C1A25'], ['burgundy', '#5C1A25'], ['magenta', '#B0287A'], ['oliva', '#6E7140'], ['olive', '#6E7140'], ['beige', '#D9C7A5'],
    ['arancion', '#F08A24'], ['arancio', '#F08A24'], ['orange', '#F08A24'], ['azzurr', '#7FB8E6'], ['viola', '#6B3FA0'], ['purple', '#6B3FA0'],
    ['marron', '#7A5232'], ['brown', '#7A5232'], ['cammello', '#A57A4E'], ['dorat', '#C8A55E'], ['gold', '#C8A55E'], ['oro', '#C8A55E'],
    ['argentat', '#B9BCC2'], ['silver', '#B9BCC2'], ['argento', '#B9BCC2'], ['bronzat', '#9C6B3C'], ['bronz', '#9C6B3C'], ['rame', '#B0643A'], ['copper', '#B0643A'],
    ['naturale', '#C9A27A'], ['legno', '#B8895A'],
    ['verd', '#3F7D3A'], ['green', '#3F7D3A'], ['blu', '#2D5BB8'], ['blue', '#2D5BB8'], ['ross', '#C62F2F'], ['red', '#C62F2F'],
    ['rosa', '#F2A0BE'], ['pink', '#F2A0BE'], ['giall', '#F2CB2E'], ['yellow', '#F2CB2E'], ['bianc', '#FFFFFF'], ['white', '#FFFFFF'],
    ['ner', '#151515'], ['black', '#151515'], ['grigi', '#8C8C8C'], ['grig', '#8C8C8C'], ['grey', '#8C8C8C'], ['gray', '#8C8C8C'],
    ['caldo', '#FFE2A8'], ['warm', '#FFE2A8'], ['freddo', '#E6F1FF'], ['cold', '#E6F1FF']
  ];
  var RAINBOW = 'conic-gradient(#E64545,#F2A23A,#F2DB3A,#4FB861,#3A86E6,#9A5BD6,#E64545)';
  var paintOf = function (cols) {
    if (cols.length === 1) return cols[0];
    if (cols.length === 2) return 'linear-gradient(135deg,' + cols[0] + ' 50%,' + cols[1] + ' 50%)';
    var step = 360 / cols.length;
    return 'conic-gradient(' + cols.map(function (c, i) { return c + ' ' + Math.round(i * step) + 'deg ' + Math.round((i + 1) * step) + 'deg'; }).join(',') + ')';
  };
  return function (name, exact) {
    if (!name) return '';
    var low = String(name).toLowerCase().trim();
    if (exact && exact[low]) return paintOf(exact[low]);
    if (/multicolor|multicolour|rainbow|arcobaleno|misto|mixed|personalizzat|custom|gradazioni/.test(low)) {
      if (!/gradazioni/.test(low)) return RAINBOW;
    }
    // drop labels such as "Base:", "Esterno:", "Frutti:"
    var text = ' ' + low.replace(/[a-zàèéìòù ]+:/g, ' ') + ' ';
    var found = [];
    var taken = [];
    C.forEach(function (pair) {
      var from = 0, at;
      while ((at = text.indexOf(pair[0], from)) !== -1) {
        var end = at + pair[0].length;
        var clash = taken.some(function (r) { return at < r[1] && end > r[0]; });
        var startsWord = /[^a-zàèéìòù]/.test(text.charAt(at - 1));
        if (!clash && startsWord) { taken.push([at, end]); found.push([at, pair[1]]); }
        from = end;
      }
    });
    found.sort(function (a, b) { return a[0] - b[0]; });
    var cols = [];
    found.forEach(function (f) { if (cols[cols.length - 1] !== f[1]) cols.push(f[1]); });
    if (/gradazioni/.test(low)) return 'linear-gradient(135deg,#FFFFFF 0 33%,#FFF0D6 33% 66%,#E6F1FF 66%)';
    return cols.length ? paintOf(cols.slice(0, 4)) : '';
  };
})();

/* Product page: gallery, variant picker with price differences, quantity, delivery estimate, sticky bar. */
(function () {
  'use strict';

  function money(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withSep = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.') + ',' + parts[1];
    var noDec = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return (format || '€{{amount_with_comma_separator}}')
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withSep)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, noDec)
      .replace(/\{\{\s*amount\s*\}\}/, value)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, parts[0])
      .replace(/<[^>]*>/g, '');
  }

  function init(section) {
    var dataEl = section.querySelector('[data-product-json]') || document.querySelector('[data-product-json]');
    if (!dataEl || section.dataset.ready) return;
    section.dataset.ready = '1';
    var data = JSON.parse(dataEl.textContent);
    var form = section.querySelector('[data-product-form]');
    var idInput = section.querySelector('[data-variant-id]');
    var priceEl = section.querySelector('[data-price]');
    var compareEl = section.querySelector('[data-compare]');
    var addBtn = section.querySelector('[data-add]');
    var addLabel = section.querySelector('[data-add-label]');
    var mirror = document.querySelector('[data-price-mirror]');
    var mainImg = section.querySelector('#gal-img');
    var thumbs = section.querySelector('[data-thumbs]');
    var optionsBox = section.querySelector('[data-options]');
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    /* ---- gallery ---- */
    /* special crowns: a strip on the main photo when the combination has no photo, or the photo is the classic crown's */
    var flag = section.querySelector('[data-photo-flag]');
    function setFlag(mode) {
      if (!flag) return;
      flag.dataset.mode = mode || '';
      flag.hidden = !mode;
    }
    function showMedia(btn) {
      if (!btn || !mainImg) return;
      setFlag(btn.hasAttribute('data-classic') ? 'classic' : '');
      thumbs.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-current', b === btn ? 'true' : 'false'); });
      // keep the chosen thumbnail visible inside its own scrolling strip, without moving the page
      var vertical = thumbs.scrollHeight > thumbs.clientHeight + 1;
      thumbs.scrollTo(vertical
        ? { top: btn.offsetTop - thumbs.offsetTop - (thumbs.clientHeight - btn.offsetHeight) / 2, behavior: reduce ? 'auto' : 'smooth' }
        : { left: btn.offsetLeft - thumbs.offsetLeft - (thumbs.clientWidth - btn.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
      // Load the new photo first, then swap: the old one stays on screen until the new one is ready,
      // so the picture never fades out to show the same photo and then jumps.
      var token = (showMedia.token = (showMedia.token || 0) + 1);
      var swap = function () {
        if (token !== showMedia.token) return;
        mainImg.srcset = btn.dataset.srcset || '';
        mainImg.src = btn.dataset.src;
        mainImg.alt = btn.dataset.alt;
      };
      var reveal = function () {
        if (token !== showMedia.token) return;
        swap();
        // the new photo is already loaded: a short fade-in, which never delays the swap itself
        if (!reduce && mainImg.animate) mainImg.animate([{ opacity: 0.35 }, { opacity: 1 }], { duration: 220, easing: 'ease-out' });
      };
      var pre = new Image();
      pre.sizes = mainImg.getAttribute('sizes') || '100vw';
      if (btn.dataset.srcset) pre.srcset = btn.dataset.srcset;
      pre.src = btn.dataset.src;
      var once = false;
      var go = function () { if (once) return; once = true; reveal(); };
      if (pre.complete && pre.naturalWidth) go();
      else { pre.onload = go; pre.onerror = go; setTimeout(go, 2500); }
    }
    if (thumbs) thumbs.addEventListener('click', function (e) { showMedia(e.target.closest('button')); });

    /* ---- options: ask Shopify for the exact combination (works beyond 250 variants) ---- */
    /* special crowns: the photo of the chosen colour × accessory comes from a map, not from the variant */
    var photoMap = null;
    try { var pm = section.querySelector('[data-photo-map]'); if (pm) photoMap = JSON.parse(pm.textContent); } catch (e) {}
    function photoFor() {
      if (!photoMap || !optionsBox) return null;
      var idx = [0, 1].map(function (n) {
        var fs = optionsBox.querySelector('[data-option="' + n + '"]');
        if (!fs) return -1;
        var inputs = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]'));
        return inputs.indexOf(fs.querySelector('input:checked'));
      });
      return idx[0] >= 0 && idx[1] >= 0 && photoMap[idx[0]] ? photoMap[idx[0]][idx[1]] : null;
    }
    function applyVariant(v, fromUser) {
      if (!v) return;
      idInput.value = v.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
      priceEl.textContent = v.price;
      if (mirror) mirror.textContent = v.price;
      if (compareEl) { compareEl.hidden = !v.compare; compareEl.textContent = v.compare || ''; }
      addBtn.disabled = !v.available;
      addLabel.textContent = v.available ? data.labels.add : data.labels.soldOut;
      // special crowns: say so when this combination has no photo of its own
      section.querySelectorAll('[data-photo-note]').forEach(function (n) { n.hidden = !!v.media; });
      var mapped = photoFor();
      if (!v.media && !mapped) setFlag('none');
      if (fromUser) {
        var mid = mapped || v.media;
        if (mid && thumbs) showMedia(thumbs.querySelector('[data-media-id="' + mid + '"]'));
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    var pending;
    if (optionsBox) {
      optionsBox.addEventListener('change', function (e) {
        var changed = e.target;
        var fs = changed.closest('[data-option]');
        var ids = Array.prototype.map.call(optionsBox.querySelectorAll('[data-option]'), function (f) {
          if (f === fs) return changed.value;
          var c = f.querySelector('input:checked');
          return c ? c.value : '';
        });
        var focusName = changed.name, focusValue = changed.value;
        addBtn.disabled = true;
        optionsBox.setAttribute('aria-busy', 'true');
        if (pending) pending.abort();
        pending = new AbortController();
        fetch(optionsBox.dataset.url + '?option_values=' + ids.join(',') + '&section_id=' + optionsBox.dataset.section, { signal: pending.signal })
          .then(function (r) { return r.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var fresh = doc.querySelector('[data-options]');
            if (!fresh) throw new Error('no options');
            paintSwatches(fresh);
            optionsBox.innerHTML = fresh.innerHTML;
            optionsBox.removeAttribute('aria-busy');
            var vEl = optionsBox.querySelector('[data-variant]');
            applyVariant(vEl ? JSON.parse(vEl.textContent) : null, true);
            var again = optionsBox.querySelector('input[name="' + focusName + '"][value="' + focusValue + '"]');
            if (again && document.activeElement === document.body) again.focus({ preventScroll: true });
          })
          .catch(function (err) {
            if (err.name === 'AbortError') return;
            optionsBox.removeAttribute('aria-busy');
            addBtn.disabled = false;
          });
      });
    }

    /* ---- colour swatches ----
       Every colour circle is worked out from the value's Italian name (fetched from the store's main language,
       so it works the same on /en, /es…): first the exact list in the theme settings, then colour words
       found in the name ("Base: Verde | Frutti: Rosso-Rosa-Blu" becomes three slices). */
    var swatchNames = null;
    var exact = {};
    try {
      var mapEl = section.querySelector('[data-swatch-map]');
      (JSON.parse(mapEl ? mapEl.textContent : '""') || '').split(/\n/).forEach(function (line) {
        var i = line.indexOf(':');
        if (i > 0) exact[line.slice(0, i).trim().toLowerCase()] = line.slice(i + 1).trim().split(/\s+/);
      });
    } catch (e) {}
    var paintSwatches = function (root) {
      root.querySelectorAll('[data-swatches]').forEach(function (g) {
        var list = (swatchNames && swatchNames[parseInt(g.dataset.swatches, 10) - 1]) || [];
        g.querySelectorAll('[data-sw]').forEach(function (lab) {
          if (lab.hasAttribute('data-sw-native')) return;
          var name = list[parseInt(lab.dataset.sw, 10)] || lab.title;
          var bg = LU_SWATCH(name, exact);
          if (bg) lab.querySelector('span').style.background = bg;
        });
      });
    };
    if (section.querySelector('[data-swatches]')) {
      if (section.dataset.primaryLocale === 'true') {
        paintSwatches(section);
      } else {
        // Italian option names: the product in the store's main language, found through its x-default
        // alternate link (on translated storefronts the handle in the page is the translated one)
        var mainUrl = '/products/' + encodeURIComponent(section.dataset.handle);
        var alt = document.querySelector('link[rel="alternate"][hreflang="x-default"]');
        if (alt) {
          try {
            var u = new URL(alt.href, location.href);
            if (u.origin === location.origin && u.pathname.indexOf('/products/') === 0) mainUrl = u.pathname;
          } catch (e) {}
        }
        paintSwatches(section);
        fetch(mainUrl.replace(/\/$/, '') + '.js', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) { if (p) swatchNames = p.options.map(function (o) { return o.values; }); paintSwatches(section); })
          .catch(function () {});
      }
    }

    /* ---- quantity ---- */
    var qty = section.querySelector('[data-qty-input]');
    section.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        qty.value = Math.min(99, Math.max(1, (parseInt(qty.value, 10) || 1) + parseInt(b.dataset.qty, 10)));
      });
    });

    /* ---- delivery estimate in working days ---- */
    // Shown as a range ("between Friday 30 October and Friday 6 November") counted in working days
    var addWorkingDays = function (days) {
      var d = new Date();
      while (days > 0) {
        d.setDate(d.getDate() + 1);
        if (d.getDay() !== 0 && d.getDay() !== 6) days--;
      }
      return d;
    };
    section.querySelectorAll('[data-eta]').forEach(function (box) {
      var max = parseInt(box.dataset.eta, 10) || 9;
      var min = Math.min(parseInt(box.dataset.etaMin, 10) || max, max);
      var lang = document.documentElement.lang || 'it';
      var fmt = function (d) { return d.toLocaleDateString(lang, { weekday: 'long', day: 'numeric', month: 'long' }); };
      var out = box.querySelector('[data-eta-date]');
      if (!out) return;
      out.textContent = min === max ? fmt(addWorkingDays(max)) + '.' : fmt(addWorkingDays(min)) + ' ' + (box.dataset.etaAnd || 'e') + ' ' + fmt(addWorkingDays(max)) + '.';
    });

    /* ---- sticky add-to-cart on phones once the real button scrolls away ---- */
    var bar = document.querySelector('[data-mobile-bar]');
    if (bar && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        var show = !entries[0].isIntersecting && entries[0].boundingClientRect.top < 0;
        bar.classList.toggle('show', show);
        bar.setAttribute('aria-hidden', show ? 'false' : 'true');
        bar.querySelector('button').tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      bar.querySelector('[data-mobile-add]').addEventListener('click', function () {
        addBtn.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' });
        addBtn.focus({ preventScroll: true });
      });
    }
  }

  function boot() { document.querySelectorAll('[data-product-section]').forEach(init); }
  document.addEventListener('shopify:section:load', boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();

/* Easify fields on the crown: name the colour fields after the accessories and ribbon actually chosen,
   and hide the optional ones that do not apply. Matched by property name, so labels can change in the app. */
(function () {
  /* Works in every storefront language: option names and values are recognised by a few words per language,
     and the labels come from the theme locales (products.easify.*) printed by main-product.liquid. */
  var ART = { rose: 'delle rose', tulipani: 'dei tulipani', girasoli: 'dei girasoli', bacche: 'delle bacche', nebbiolina: 'della nebbiolina' };
  var WORDS = {
    accessori: /accessor|zubeh/i,
    fiocco: /fiocco|bow|lazo|n(œ|oe)ud|schleife/i
  };
  var NONE = /nessun|none|ningun|aucun|kein/i;
  var DOUBLE = /doppio|double|doble|doppel/i;
  var LETTERING = /vinil|vinyl|vinyle|ricam|embroider|bordad|brod|stick/i;
  var T = { color_of: 'Colore {{ name }}', ribbon: 'Colore del nastro', first_ribbon: 'Colore del primo nastro', pick_colour: 'Scegli il colore degli accessori che hai selezionato.' };
  try { var tEl = document.getElementById('lu-easify-i18n'); if (tEl) T = Object.assign(T, JSON.parse(tEl.textContent)); } catch (e) {}
  var italian = /^it/i.test(document.documentElement.lang || 'it');
  function chosen(word) {
    var out = '';
    var re = WORDS[word];
    document.querySelectorAll('[data-options] .opt').forEach(function (fs) {
      var h = fs.querySelector('.opt-h');
      var v = fs.querySelector('.sw-name');
      if (h && v && re.test(h.textContent)) out = v.textContent.trim();
    });
    return out;
  }
  function box(prop) {
    var input = document.querySelector('.tpo_option-set-wrapper [name="properties[' + prop + ']"]');
    return input ? input.closest('.tpo_option-container') : null;
  }
  function label(el, text) {
    var l = el && el.querySelector('.form__label');
    if (!l) return;
    if (!l.dataset.luOrig) l.dataset.luOrig = l.textContent.trim();
    l.textContent = text || l.dataset.luOrig;
  }
  function show(el, on) { if (el) el.hidden = !on; }
  function warn(el, on) {
    if (!el) return;
    var w = el.querySelector('.lu-easify-warn');
    if (on && !w) { w = document.createElement('p'); w.className = 'lu-easify-warn'; w.setAttribute('role', 'alert'); w.textContent = T.pick_colour; el.appendChild(w); }
    if (!on && w) w.remove();
  }
  function needsColour() {
    var acc = chosen('accessori');
    if (!acc || NONE.test(acc)) return null;
    var p1 = box('Colore accessori principali');
    var v = p1 && p1.querySelector('input');
    return v && NONE.test(v.value) ? p1 : null;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-add]');
    if (!btn) return;
    var bad = needsColour();
    if (!bad) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    warn(bad, true);
    bad.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }, true);
  function colourOf(name) {
    var k = name.toLowerCase().trim();
    if (italian) return 'Colore ' + (ART[k] || k);
    return T.color_of.replace('{{ name }}', name.trim());
  }
  function apply() {
    var p1 = box('Colore accessori principali');
    if (!p1) return false;
    var acc = chosen('accessori');
    var parts = acc && !NONE.test(acc) ? acc.split('+').map(function (x) { return x.trim(); }).filter(Boolean) : [];
    var p2 = box('Colore accessori secondari');
    label(p1, parts[0] ? colourOf(parts[0]) : '');
    label(p2, parts[1] ? colourOf(parts[1]) : '');
    show(p2, parts.length > 1);
    if (!parts.length) {
      /* No accessories: Easify still requires this field, so pick its "Nessun accessorio" value and hide it. */
      var p1in = p1.querySelector('input');
      if (p1in && !NONE.test(p1in.value)) {
        var none = Array.prototype.find.call(p1.querySelectorAll('button.tpo_option-type-selection'), function (b) { return NONE.test(b.textContent); });
        if (none) none.click();
      }
      show(p1, false);
    } else {
      show(p1, true);
    }
    warn(p1, false);

    var fiocco = chosen('fiocco').toLowerCase();
    if (fiocco) {
      var doppio = DOUBLE.test(fiocco);
      var scritta = LETTERING.test(fiocco);
      show(box('Colore nastro 2'), doppio);
      show(box('Colore scritta'), scritta);
      show(box('Personalizzazione fiocco 1'), scritta);
      show(box('Personalizzazione fiocco 2'), scritta);
      label(box('Colore nastro'), doppio ? T.first_ribbon : T.ribbon);
    }
    return true;
  }
  /* What reaches the order: the same names the customer saw (in Italian, for the lab), and none of the
     empty or not-applicable fields. Inputs are renamed or unnamed only for the moment the form is sent. */
  function orderName(prop) {
    var acc = chosen('accessori');
    var parts = acc && !NONE.test(acc) ? acc.split('+').map(function (x) { return x.trim().toLowerCase(); }).filter(Boolean) : [];
    var doppio = DOUBLE.test(chosen('fiocco'));
    if (prop === 'Colore accessori principali' && parts[0]) return 'Colore ' + (ART[parts[0]] || parts[0]);
    if (prop === 'Colore accessori secondari' && parts[1]) return 'Colore ' + (ART[parts[1]] || parts[1]);
    if (prop === 'Colore nastro') return doppio ? 'Colore del primo nastro' : 'Colore del nastro';
    if (prop === 'Colore nastro 2') return 'Colore del secondo nastro';
    return prop;
  }
  function prepareOrder(form) {
    if (form.dataset.luPrepared) return;
    form.dataset.luPrepared = '1';
    var undo = [];
    form.querySelectorAll('.tpo_option-set-wrapper [name^="properties["]').forEach(function (input) {
      var prop = input.name.slice(11, -1);
      if (prop.charAt(0) === '_') return;
      var c = input.closest('.tpo_option-container');
      var off = (c && c.hidden) || !String(input.value || '').trim() || (input.type === 'radio' || input.type === 'checkbox') && !input.checked;
      var original = { el: input, name: input.name };
      /* Easify re-enables its inputs on submit, so an empty field is left out by taking its name away. */
      if (off) { input.removeAttribute('name'); undo.push(original); return; }
      var name = orderName(prop);
      if (name !== prop) { input.name = 'properties[' + name + ']'; undo.push(original); }
    });
    setTimeout(function () { undo.forEach(function (u) { u.el.name = u.name; }); delete form.dataset.luPrepared; }, 4000);
  }
  document.addEventListener('submit', function (e) {
    try { if (e.target.querySelector('.tpo_option-set-wrapper')) prepareOrder(e.target); } catch (err) {}
  }, true);
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-add]');
    if (!btn || needsColour()) return;
    var form = btn.form || btn.closest('form');
    try { if (form && form.querySelector('.tpo_option-set-wrapper')) prepareOrder(form); } catch (err) {}
  }, true);

  function boot() {
    var tries = 0;
    (function wait() { if (apply() || ++tries > 40) return; setTimeout(wait, 250); })();
    var opts = document.querySelector('[data-options]');
    if (opts && window.MutationObserver) new MutationObserver(function () { apply(); }).observe(opts, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();


/* Easify fields that only make sense with lettering on the bow (Theme settings > Prodotti): hidden, and left out
   of the order, while the chosen bow is plain. Easify's own conditions on variants are a paid feature. */
(function () {
  var cfgEl = document.querySelector('[data-bow-only]');
  if (!cfgEl) return;
  var norm = function (t) { return String(t || '').replace(/\*/g, '').replace(/\s+/g, ' ').trim().toLowerCase(); };
  var base = [];
  try { base = JSON.parse(cfgEl.textContent).map(norm).filter(Boolean); } catch (e) {}
  if (!base.length) return;
  function labels() {
    var tr = window.luEasifyTr;
    var out = base.slice();
    if (tr) JSON.parse(cfgEl.textContent).forEach(function (l) { var t = tr(String(l).trim()); if (t) out.push(norm(t)); });
    return out;
  }
  function apply() {
    var fs = document.querySelector('[data-bow-text]');
    if (!fs) return;
    var show = fs.getAttribute('data-bow-text') === 'true';
    var list = labels();
    document.querySelectorAll('.tpo_option-container').forEach(function (c) {
      var l = c.querySelector('.form__label');
      if (!l) return;
      var t = norm(l.textContent);
      if (!list.some(function (x) { return t === x; })) return;
      c.style.display = show ? '' : 'none';
      c.classList.toggle('lu-bow-off', !show);
      // a hidden field must not reach the order: its properties[...] input loses its name until it shows again
      c.querySelectorAll('[name^="properties["], [data-lu-prop]').forEach(function (i) {
        if (!show && i.name) { i.setAttribute('data-lu-prop', i.name); i.removeAttribute('name'); }
        if (show && i.getAttribute('data-lu-prop')) { i.name = i.getAttribute('data-lu-prop'); i.removeAttribute('data-lu-prop'); }
      });
    });
  }
  var t = null;
  var later = function () { clearTimeout(t); t = setTimeout(apply, 60); };
  if (window.MutationObserver) new MutationObserver(later).observe(document.body, { childList: true, subtree: true });
  document.addEventListener('change', later, true);
  // run once more right before adding to the cart, in case Easify redrew its fields in the meantime
  var guard = function (e) { if (e.type === 'submit' || (e.target.closest && e.target.closest('[data-add], [type="submit"][name="add"]'))) apply(); };
  document.addEventListener('submit', guard, true);
  document.addEventListener('click', guard, true);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', apply); else apply();
})();
